export default __webpack_public_path__ + "static/media/blade_alpha.fd72bbc9.jpg";